import HP from "../host";
import { PaginationParamsType } from "../types/common";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const RequestSignatureService = {
  create: async (body: object) => {
    return await api.post("/signature-request/create", body);
  },
  getAllRequests: async (params: PaginationParamsType) => {
    return await api.get(
      `/signature-request/find?page=${params.page}&per_page=${
        params.per_page
      }&query=${params.query || ""}`
    );
  },
  getApprovedRatings: async () => {
    return await api.get("/signature-request/get-approved-ratings");
  },
  getSingleRequest: async (id: string) => {
    return await api.get(`/signature-request/find/${id}`);
  },
  updateRequest: async (id: string, body: object) => {
    return await api.put(`/signature-request/update/${id}`, body);
  },
  updateRequestStatus: async (id: string, body: FormData) => {
    return await api.postFormData(
      `/signature-request/update-status/${id}`,
      body,
      { method: "PUT" }
    );
  },
  removeRequest: async (id: string) => {
    return await api.delete(`/signature-request/delete/${id}`);
  },
};
export default RequestSignatureService;
